import React from 'react';
import PropTypes from 'prop-types';

export const ErrorMessage = ({ meta }) => (
    <div>
        {meta.error && meta.touched && (
            <span className="block px-1 ml-1 mt-1 text-xs italic text-center w-full text-red-700 bg-red-200">
                {' '}
                {meta.error}{' '}
            </span>
        )}
    </div>
);
ErrorMessage.propTypes = {
    meta: PropTypes.object,
};
